export default __webpack_public_path__ + "static/media/typical-icon.59d11da7.svg";